$( document ).ready(function() {
    $(document).on('blur', '.component-Products-BuyForm input[name="amount"]', function () {
        if ($(this).val().trim() === '' || parseInt($(this).val(), 10) < 1) {
            $(this).val(1);
        }
    });

    $(document).on('submit', '.component-Products-BuyForm form.ajax', function () {
        let $amount = $(this).find('input[name="amount"]');
        if ($amount.length && ($amount.val().trim() === '' || parseInt($amount.val(), 10) < 1)) {
            $amount.val(1);
        }
    });
});